/* eslint-disable */
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '@mui/material';
import { useEffect, useReducer, useState } from 'react';
import { connect } from 'react-redux';
import styles from './UtilitiesCreatePage.module.scss';
import CreateFormpage from '../../../Components/CreateFormpage/CreateFormpage';
import formStyles from '../../../Components/CreateFormpage/CreateFormpage.module.scss';
import { CreatePageHeader } from '../../../Components/Headers';
import { formActions, modalActions } from '../../../Actions';
import utilitiesCreateConfig from './utilitiesCreate.config';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import {
	getStateCodeFromGSTIN,
	getTaxFromStr,
	useQuery,
} from '../../../Helpers';
import { BackdropLoader } from '../../../Components/Loaders';
import BillAlreadyPaidInputs from '../../PettyCash/PettyCashCreatePage/BillAlreadyPaidInputs/BillAlreadyPaidInputs';
import { urls } from '../../../Constants';
// import POTotalContainer from '../../../Components/POTotalContainer/POTotalContainer';

const UtilitiesCreatePage = (props) => {
	const query = useQuery();
	const history = useHistory();
	const queryToStore = query.get('toStore');
	const id = query.get('id');
	const edit = query.get('edit');

	const { fetchVendors, vendorsList, storesList, toggleFileUploaderModal, fetchStoresList } =
		props;
	const [state, dispatch] = useReducer(
		utilitiesCreateConfig?.reducer,
		utilitiesCreateConfig?.initialState
	);
	const [categoryList, setCategoryList] = useState([]);
	const [taxSlabsList, setTaxSlabsList] = useState([]);
	const [isLoading, setIsloading] = useState(false);

	const fetchCategoryList = async (catType = 'UTILITIES') => {
		try {
			const response = await inventoryAnalyticsServices.fetchCategoryList(
				{
					req: {
						data: {
							type: catType,
						},
					},
				}
			);
			if (response?.statusCode === 200) {
				if (catType === 'UTILITIES') {
					setCategoryList(response?.data?.categories);
				} else if (catType === 'TAX_SLAB') {
					setTaxSlabsList(response?.data?.categories);
				}
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('error', error);
		}
	};

	useEffect(() => {
		fetchVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchVendors({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'FILTERED_STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchCategoryList();
		fetchCategoryList('TAX_SLAB');
	}, []);

	useEffect(() => {
		if (queryToStore && queryToStore !== 'undefined') {
			const newStore = storesList?.find((ele) => {
				return ele?.id === Number(queryToStore);
			});
			dispatch({
				type: 'SET_STORE',
				payload: newStore,
			});
		}
	}, [queryToStore, storesList]);

	const handleSubmit = async () => {
		const isInvalid = utilitiesCreateConfig?.validator(state);
		// if (state?.periodTo > state?.billDate) {
		// notificationServices.generateNotification({
		// type: 'error',
		// message:
		// 'The period of the cycle should end before the selected bill date.',
		// });
		// return;
		// }
		if (state?.amount?.includes('-') || state?.amount <= 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please Enter valid Amount',
			});
			return;
		}
		if (isInvalid) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Please enter Mandatory Fields',
			});
			return;
		}
		setIsloading(true);
		const deserializedData = utilitiesCreateConfig?.deserializer(state);
		const req = {
			data: {
				...deserializedData,
				nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.UTILITIES_PAGE}?clientUtilityId=${deserializedData?.clientOrderId}`,
			},
		};
		try {
			const response =
				await inventoryAnalyticsServices.createTransactionRecord(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						duration: 10000,
					},
				});
				dispatch({
					type: 'INIT',
				});
				history.goBack();
			}
		} catch ({ name, message }) {
			notificationServices?.generateNotification({
				type: 'error',
				// eslint-disable-next-line prefer-template
				message,
			});
		} finally {
			setIsloading(false);
		}
	};

	const handleSaveEdit = async () => {
		const isInvalid = utilitiesCreateConfig?.validator(state);
		if (String(state?.amount)?.includes('-') || state?.amount <= 0) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Please Enter valid Amount',
			});
			return;
		}
		if (isInvalid) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Please enter Mandatory Fields',
			});
			return;
		}
		setIsloading(true);
		const deserializedData = utilitiesCreateConfig?.deserializer(state, true);
		const req = {
			params: {
				transactionId: id,
			},
			data: {
				...deserializedData,
				nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.UTILITIES_PAGE}?clientUtilityId=${deserializedData?.clientOrderId}`,
			},
		};

		try {
			const response =
				await inventoryAnalyticsServices.editTransactionRecord(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						duration: 10000,
					},
				});
				dispatch({
					type: 'INIT',
				});
				history.push(`${urls.EXTENSION}${urls.UTILITIES_PAGE}`);
			}
		} catch ({ name, message }) {
			notificationServices?.generateNotification({
				type: 'error',
				// eslint-disable-next-line prefer-template
				message,
			});
		} finally {
			setIsloading(false);
		}
	}

	const handleSave = () => {
		if (edit) {
			handleSaveEdit();
		} else {
			handleSubmit();
		}
	}

	const renderBtns = () => {
		return (
			<div className={styles.btns}>
				<Button
					onClick={() => {
						handleSave();
					}}
					variant='contained'
					color='primary'
					type='button'
				>
					{edit ? 'Update' : 'Save'}
				</Button>
			</div>
		);
	};

	const handleBackClick = () => {
		history.goBack();
	};

	const handleVendorSelection = (newVendor) => {
		dispatch({
			type: 'SET_VENDOR',
			payload: newVendor,
		});
	};

	const handleStoreSelection = (newStore) => {
		dispatch({
			type: 'SET_STORE',
			payload: newStore,
		});
	};

	const handleRemoveVendor = (e) => {
		if (e) {
			if (e === 'vendor' || e.keyCode === 8) {
				dispatch({
					type: 'SET_VENDOR',
					payload: {},
				});
			}
		}
	};
	const handleRemoveStore = (e) => {
		if (e) {
			if (e === 'store' || e.keyCode === 8) {
				dispatch({
					type: 'SET_STORE',
					payload: {},
				});
			}
		}
	};
	const handleDescription = (value) => {
		return dispatch({
			type: 'SET_DESCRIPTION',
			payload: value
		});
	};

	const handleDateSelection = (newDate, type) => {
		dispatch({
			type,
			payload: newDate,
		});
	};

	// async function fetchTempId() {
	// 	if (state?.clientTransactionId) return;
	// 	try {
	// 		const response = await inventoryAnalyticsServices.fetchPOId();
	// 		if (response?.statusCode === 200) {
	// 			dispatch({
	// 				type: 'SET_UTILITY_ID',
	// 				payload: response?.data,
	// 			});
	// 		}
	// 	} catch (error) {
	// 		// eslint-disable-next-line no-console
	// 		console.log(error);
	// 	}
	// }

	useEffect(async () => {
		if (id && edit && vendorsList?.length > 0 && storesList?.length > 0 && categoryList?.length > 0) {
			const response = await inventoryAnalyticsServices.getTransactionRecord({
				params: {
					transactionId: id,
				},
			});
			if (response?.statusCode === 200) {
				const data = response?.data;
				const serializedData = await utilitiesCreateConfig?.serializer(data, vendorsList, storesList, categoryList);
				dispatch({
					type: 'SET_STATE',
					payload: serializedData,
				});
			}
		}
		// fetchTempId();
	}, [edit, id, vendorsList, storesList, categoryList]);

	console.log(state, 'state');
	const isStateTax = (vendorGst, storeGst) => {
		if (
			getStateCodeFromGSTIN(vendorGst) === getStateCodeFromGSTIN(storeGst)
		) {
			return true;
		}
		return false;
	};

	const handleBillNo = (e) => {
		const value = e.target.value;
		if (value.length > 20) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Bill No cannot be more than 20 digits',
			});
			return;
		}
		return dispatch({
			type: 'SET_BILL_NO',
			payload: value
		});
	}

	function formattedInputs(mainList = []) {
		const vendorGst = state?.vendor?.gstin;
		const storeGst = state?.store?.gstNumber;
		let vendorHaveGst = false;
		let isSameState = false;
		// eslint-disable-next-line no-unused-vars, prefer-const
		let extraLabelData = { color: 'green' };
		let tax = 0;
		if (vendorGst && vendorGst?.length > 0 && storeGst) {
			vendorHaveGst = true;
			isSameState = isStateTax(vendorGst, storeGst);
			if (state?.taxSlab) {
				tax = getTaxFromStr(state.taxSlab);
				if (!isSameState) {
					extraLabelData.text = `IGST ${tax.toFixed(1)}% `;
				} else {
					extraLabelData.text = `SGST ${(tax / 2).toFixed(
						1
					)}%  |  CGST ${(tax / 2).toFixed(1)}%`;
				}
			} else {
				// eslint-disable-next-line no-lonely-if
				if (!isSameState) {
					extraLabelData.text = 'IGST';
				} else {
					extraLabelData.text = 'SGST | CGST';
				}
			}
			// eslint-disable-next-line no-unused-vars
		}
		let list = mainList;
		if (!vendorHaveGst) {
			list = list?.filter((ele) => {
				return !['taxSlab', 'taxAmount', 'subTotal'].includes(ele?.id);
			});
		}

		return list?.map((ele) => {
			if (Array.isArray(ele)) {
				return formattedInputs(ele);
			}
			// Tax Amount / Sub Total: the amount entered includes tax, so
			// tax = amount x rate / (100 + rate) and sub total = amount - tax.
			if (ele?.inputType === 'customComponent' && ['taxAmount', 'subTotal'].includes(ele?.id)) {
				const amount = Number(state?.amount);
				const hasAmount = state?.amount !== '' && state?.amount != null && !Number.isNaN(amount);
				const taxAmount = hasAmount && tax > 0 ? (amount * tax) / (100 + tax) : 0;
				const fmt = (n) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
				let valueText = '-';
				let hint = null;
				if (hasAmount && ele.id === 'taxAmount') {
					valueText = `\u20B9 ${fmt(taxAmount)}`;
					if (taxAmount > 0) {
						hint = isSameState
							? `SGST \u20B9 ${fmt(taxAmount / 2)}  |  CGST \u20B9 ${fmt(taxAmount / 2)}`
							: `IGST \u20B9 ${fmt(taxAmount)}`;
					}
				}
				if (hasAmount && ele.id === 'subTotal') {
					valueText = `\u20B9 ${fmt(amount - taxAmount)}`;
				}
				return {
					...ele,
					component: (
						<div className={formStyles.tile} key={ele.id}>
							<label htmlFor={ele.id}>
								{ele.id === 'taxAmount' ? 'Tax Amount' : 'Sub Total (excl. Tax)'}
							</label>
							<div style={{ width: 250 }}>
								<p id={ele.id} className='m-0 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-[15px]'>
									{valueText}
								</p>
								{hint && <p className='m-0 mt-1 text-[12px] text-green-700'>{hint}</p>}
							</div>
						</div>
					),
				};
			}
			if (ele?.inputType === 'customComponent') {
				return {
					...ele,
					component: (
						<BillAlreadyPaidInputs
							disabled={!!edit && state?.alreadyPaid?.isPaid != null}
							state={{
								checkValue: state?.alreadyPaid?.isPaid,
								uploadedDoc: {
									file: state?.alreadyPaid?.uploadedDocFile,
									fileName:
										state?.alreadyPaid?.uploadedDocFileName,
								},
								paymentMode: state?.alreadyPaid?.paymentMode,
								transactionRefNumber: state?.alreadyPaid?.transactionRefNumber,
							}}
							setState={(fields) => {
								if (fields?.uploadedDoc) {
									dispatch({
										type: 'SET_ALREADY_PAID',
										payload: {
											...state?.alreadyPaid,
											isNewDoc: true,
											uploadedDocFile:
												fields?.uploadedDoc?.file,
											uploadedDocFileName:
												fields?.uploadedDoc?.fileName,
										},
									});
									return;
								}
								if (fields?.paymentMode) {
									dispatch({
										type: 'SET_ALREADY_PAID',
										payload: {
											...state?.alreadyPaid,
											paymentMode: fields?.paymentMode,
										},
									});
									return;
								}
								if (fields?.transactionRefNumber || fields?.transactionRefNumber === '') {
									dispatch({
										type: 'SET_ALREADY_PAID',
										payload: {
											...state?.alreadyPaid,
											transactionRefNumber:
												fields?.transactionRefNumber,
										},
									});
									return;
								}
								dispatch({
									type: 'SET_ALREADY_PAID',
									payload: {
										...state?.alreadyPaid,
										isPaid: fields?.checkValue,
									},
								});
							}}
						/>
					),
				};
			}
			if (ele?.inputType === 'options_search' && ele?.id === 'vendor') {
				// const vendors = vendorsList.filter((item) => {
				// 	return item.vendorType === 'UTILITY';
				// });
				return {
					...ele,
					value: state?.vendor?.name,
					handleSelection: handleVendorSelection,
					optionsList: vendorsList,
					handleKeyPress: handleRemoveVendor,
					handleRemove: handleRemoveVendor,
					disabled: !!edit,
				};
			}
			if (ele?.inputType === 'options_search' && ele?.id === 'store') {
				return {
					...ele,
					value: state?.store?.name,
					handleSelection: handleStoreSelection,
					optionsList: storesList,
					handleKeyPress: handleRemoveStore,
					handleRemove: handleRemoveStore,
					disabled: !!edit,
				};
			}
			if (ele?.id === 'description') {
				return {
					...ele,
					value: state?.description,
					onChange: handleDescription,
				};
			}
			if (ele?.inputType === 'dateSelector' && ele?.id === 'periodFrom') {
				return {
					...ele,
					value: state?.periodFrom,
					oneTap: true,
					onChange: (date) => {
						handleDateSelection(date, 'SET_PERIOD_FROM');
					},
				};
			}
			if (ele?.inputType === 'dateSelector' && ele?.id === 'periodTo') {
				return {
					...ele,
					value: state?.periodTo,
					oneTap: true,
					onChange: (date) => {
						handleDateSelection(date, 'SET_PERIOD_TO');
					},
					disabledDate: (dateSelectorDate) => {
						return dateSelectorDate < state?.periodFrom;
					},
				};
			}
			if (ele?.inputType === 'dateSelector' && ele?.id === 'billDate') {
				return {
					...ele,
					value: state?.billDate,
					oneTap: true,
					onChange: (date) => {
						handleDateSelection(date, 'SET_BILL_DATE');
					},
					disabledDate: (dateSelectorDate) => {
						return dateSelectorDate >= new Date();
					},
				};
			}
			if (ele?.inputType === 'options' && ele?.id === 'taxSlab') {
				return {
					...ele,
					optionsList: taxSlabsList?.map((cat) => {
						return cat?.value;
					}),
					extraInfo: extraLabelData,
					value: state?.taxSlab || ele?.value,
					onChange: (value) => {
						dispatch({
							type: 'SET_TAX_SLAB',
							payload: value,
						});
					},
				};
			}
			if (ele?.inputType === 'dateSelector' && ele?.id === 'dueDate') {
				return {
					...ele,
					value: state?.dueDate,
					oneTap: true,
					onChange: (date) => {
						handleDateSelection(date, 'SET_DUE_DATE');
					},
					disabledDate: (dateSelectorDate) => {
						return dateSelectorDate <= state?.billDate - 1;
					},
				};
			}
			if (ele?.inputType === 'options' && ele?.id === 'utilityCategory') {
				return {
					...ele,
					optionsList: categoryList?.map((catItem) => {
						return {
							...catItem,
							title: catItem?.value,
						};
					}),
					value: state?.category?.id,
					onChange: (value) => {
						const categoryItem = categoryList?.find((currItem) => {
							return currItem?.id === Number(value);
						});
						dispatch({
							type: 'SET_CATEGORY',
							payload: categoryItem,
						});
					},
				};
			}
			if (ele?.id === 'amount') {
				return {
					...ele,
					value: state?.amount,
					onChange: (e) => {
						const value = e?.target?.value;
						const isPositiveDecimal =
							/^(?:\d+(\.\d*)?|\.\d+)?$/.test(value);
						// eslint-disable-next-line no-restricted-globals
						if (value === '' || isPositiveDecimal) {
							dispatch({
								type: 'SET_AMOUNT',
								payload: e.target.value,
							});
						}
					},
				};
			}
			if (ele?.id === 'clientTransactionId') {
				return {
					...ele,
					value: state?.clientTransactionId,
					onChange: (e) => {
						dispatch({
							type: 'SET_UTILITY_ID',
							payload: e.target.value,
						});
					},
				};
			}
			if (ele?.id === 'billNo') {
				return {
					...ele,
					value: state?.billNo,
					onChange: handleBillNo,
				};
			}
			if (ele?.inputType === 'docUploader') {
				return {
					...ele,
					value: state?.uploadedDoc,
					prefix: state?.uploadedDoc?.file ? 'Update' : 'Upload',
					btnText: 'Reference File',
					uploadFileClick: () => {
						toggleFileUploaderModal(true, {
							heading: 'Upload Vendor Invoice',
							selectedFile: '',
							confirmText: 'Upload',
							handleConfirm: (uploadedFile) => {
								dispatch({
									type: 'SET_UPLOADED_DOC',
									payload: uploadedFile,
								});
							},
						});
					},
				};
			}
			return ele;
		});
	}

	return (
		<div className={styles.root}>
			<BackdropLoader isLoading={isLoading} showProgress />
			<CreatePageHeader
				heading={`${edit ? 'Edit' : 'Add'} Utilities`}
				renderBtns={renderBtns}
				showBack
				handleBackClick={handleBackClick}
			/>
			<div className={styles.body}>
				<CreateFormpage
					inputsList={formattedInputs(
						utilitiesCreateConfig?.inputsList
					)}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { show, data } = state.modal.addVendorModal;
	const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
	const storesList = state.form.FILTERED_STORES.data.LIST;

	return {
		show,
		data,
		vendorsList,
		storesList,
	};
};

const mapDispatchToProps = {
	fetchVendors: formActions.gateway,
	fetchStoresList: formActions.gateway,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UtilitiesCreatePage);
